export enum Role {
  ADMIN,
  EXTERNAL,
}
